<template>
  <div class="message-card-area">
    <template v-if="cardVisible">
      <component :is="componentName" :card-list="cardList" :miniEnv="miniEnv"></component>
    </template>

    <template v-else>
      <Markdown :message="message" />
    </template>
  </div>
</template>

<script>
  import markdownit from 'markdown-it'
  import ExhibitorCard from './ExhibitorCard'
  import ExhibitCard from './ExhibitCard'
  import ActivityCard from './ActivityCard'
  import { isInMiniprogram } from '@/utils/util'
  import Markdown from './Markdown'
  import { mapGetters } from 'vuex'

  const md = markdownit()

  export default {
    components: {
      ExhibitorCard,
      ExhibitCard,
      ActivityCard,
      Markdown
    },
    props: {
      message: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        componentName: ''
      }
    },
    computed: {
      ...mapGetters(['miniEnv']),
      cardList() {
        const data = this.formateCardMessage()
        console.log(data, 'cardList')
        return data
      },
      cardVisible() {
        return Array.isArray(this.cardList)
      }
    },
    mounted() {},
    methods: {
      formateCardMessage() {
        try {
          const parseStr = JSON.parse(this.message.content)
          return this.handleCardMessage(parseStr)
        } catch (error) {
          return this.message.content
        }
      },
      handleCardMessage(cardMessage) {
        if (cardMessage.card_type === 3) {
          if (cardMessage.data) {
            try {
              const data = JSON.parse(cardMessage.data)
              console.log(data, '111')
              const { defaultValue } = data.variables.data
              const type = defaultValue[0].title
              const len = defaultValue.length
              const result = defaultValue || []

              if (type === "product") {
                this.componentName = 'ExhibitCard'
              } else if (type === "exhibitor") {
                this.componentName = 'ExhibitorCard'
              } else if (type === "meeting") {
                this.componentName = 'ActivityCard'
              }

              return result.map(item => {
                if (item.url) {
                  try {
                    item.url = JSON.parse(item.url)
                  } catch (error) {
                    item.url = {}
                  }
                }
                return item
              })
            } catch (error) {
              console.log('解析错误')
              return []
            }
          }
          return []
          // if (cardMessage.response_for_model) {
          //   try {
          //     return this.parseCardData(cardMessage.response_for_model)
          //   } catch (error) {
          //     return cardMessage
          //   }
          // }
          // return cardMessage
        } else {
          return cardMessage
        }
      },
      parseCardData(message) {
        const modelInfo = JSON.parse(message)

        console.log(modelInfo, 'modelInfo')
        if (modelInfo.exhibitor) {
          this.componentName = 'ExhibitorCard'
          return modelInfo.exhibitor
        }
        if (modelInfo.product) {
          this.componentName = 'ExhibitCard'
          return modelInfo.product
        }
        if (modelInfo.meeting) {
          this.componentName = 'ActivityCard'
          return modelInfo.meeting
        }
        return message
      },
      parseQueryStringToArray(queryString) {
       
      }
    }
  }
</script>

<style lang="scss" scoped>
  .message-card-area {
    width: 100%;
    padding: 12px 8px;
    box-sizing: border-box;
    border-radius: 10px 10px 10px 0px;

    word-break: break-all;
    color: rgba(0,0,0,0.65);
    font-size: 17px;
    font-size: 17px;
    line-height: 30px;
    background: #FBFBFB;
    box-shadow: 0px 2px 4px 0px rgba(7,41,177,0.05);
  }
</style>